import './MenuNavigation.scss';

import { MiddleTitle } from "../../../common-components/Titles/Titles";

import DeparturesLinks from "../../links/DeparturesLinks/DeparturesLinks";
import PreventiveLinks from "../../links/PreventiveLinks/PreventiveLinks";
import VehiclesLinks from "../../links/VehiclesLinks/VehiclesLinks";
import AlarmLinks from "../../links/AlarmLinks/AlarmLinks";


const MenuNavigation = ({ onClose }) => {

    return (
        <div className={"menu-navigation"}>
            <div className={"menu-navigation_title"}>
                <MiddleTitle property={"Меню"}/>
            </div>
            <div className={"menu-navigation_content"}>
                <DeparturesLinks onClose={onClose}/>
                <PreventiveLinks onClose={onClose}/>
                <VehiclesLinks onClose={onClose}/>
            </div>
        </div>
    )
}

export default MenuNavigation;